module.exports = "/next-static/_next/static/images/hero_image_1x-49bdfaa27c8ce1d5af7a7911cae395fc.webp";